import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Header } from '../components/Header';
import { SEO } from '../components/SEO';
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1,
      delayChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      type: 'spring',
      stiffness: 100,
      damping: 20
    }
  }
};
export function PrivacyPage() {
  return <div className="min-h-screen bg-white" data-id="element-488">
      <SEO title="Privacy Policy" description="4ALL AI privacy policy. Learn how we handle your data and protect your privacy on our AI tool directory platform." canonicalPath="/privacy" data-id="element-489" />
      <Header data-id="element-490" />

      <main className="w-full pb-24" data-id="element-491">
        <motion.section className="max-w-3xl mx-auto px-6 pt-24 pb-16" variants={containerVariants} initial="hidden" animate="visible" data-id="element-492">
          <motion.div variants={itemVariants} className="mb-16" data-id="element-493">
            <h1 className="text-5xl md:text-6xl font-bold text-black mb-6 tracking-tight" data-id="element-494">
              Privacy Policy
            </h1>
            <p className="text-xl text-grey-500" data-id="element-495">
              Last updated: March 28, 2026
            </p>
          </motion.div>

          <motion.div variants={itemVariants} className="prose prose-lg max-w-none text-grey-700 space-y-12" data-id="element-496">
            <section data-id="element-497">
              <p className="text-lg leading-relaxed" data-id="element-498">
                At 4ALL, built by Skeuomorphic xyz, we believe in transparency
                and simplicity. This Privacy Policy explains how we collect,
                use, and protect your information when you use our platform to
                discover AI tools.
              </p>
            </section>

            <section data-id="element-499">
              <h2 className="text-2xl font-bold text-black mb-4" data-id="element-500">
                1. Information We Collect
              </h2>
              <p className="mb-4" data-id="element-501">
                We collect minimal information to provide and improve our
                service:
              </p>
              <ul className="list-disc pl-6 space-y-2" data-id="element-502">
                <li data-id="element-503">
                  <strong data-id="element-504">Usage Data:</strong> Information about how you
                  interact with our platform, such as search queries, categories
                  browsed, and tools clicked.
                </li>
                <li data-id="element-505">
                  <strong data-id="element-506">Device Information:</strong> Basic analytics data
                  including browser type, device type, and approximate location
                  (country/city level).
                </li>
                <li data-id="element-507">
                  <strong data-id="element-508">Voluntary Information:</strong> Any information you
                  choose to provide if you contact us or subscribe to our
                  newsletter.
                </li>
              </ul>
            </section>

            <section data-id="element-509">
              <h2 className="text-2xl font-bold text-black mb-4" data-id="element-510">
                2. How We Use Information
              </h2>
              <p className="mb-4" data-id="element-511">
                The information we collect is used solely to:
              </p>
              <ul className="list-disc pl-6 space-y-2" data-id="element-512">
                <li data-id="element-513">Improve our search and recommendation algorithms</li>
                <li data-id="element-514">Understand which AI tools are most helpful to our users</li>
                <li data-id="element-515">Maintain and optimize the performance of our platform</li>
                <li data-id="element-516">Communicate with you (only if you've opted in)</li>
              </ul>
            </section>

            <section data-id="element-517">
              <h2 className="text-2xl font-bold text-black mb-4" data-id="element-518">
                3. Cookies and Tracking
              </h2>
              <p className="leading-relaxed" data-id="element-519">
                We use essential cookies to make our site work and analytics
                cookies to understand how people use 4ALL. We do not use
                intrusive tracking cookies or sell your data to advertisers. You
                can control cookie preferences through your browser settings.
              </p>
            </section>

            <section data-id="element-520">
              <h2 className="text-2xl font-bold text-black mb-4" data-id="element-521">
                4. Third-Party Links
              </h2>
              <p className="leading-relaxed" data-id="element-522">
                4ALL is a discovery platform that links out to external AI tools
                and services. Once you click a link to leave our site, our
                Privacy Policy no longer applies. We are not responsible for the
                privacy practices or content of these third-party tools. We
                encourage you to read the privacy policies of any tool you
                choose to use.
              </p>
            </section>

            <section data-id="element-523">
              <h2 className="text-2xl font-bold text-black mb-4" data-id="element-524">
                5. Data Security
              </h2>
              <p className="leading-relaxed" data-id="element-525">
                We implement reasonable security measures to protect the limited
                information we collect. However, no internet transmission is
                completely secure, and we cannot guarantee absolute security.
              </p>
            </section>

            <section data-id="element-526">
              <h2 className="text-2xl font-bold text-black mb-4" data-id="element-527">
                6. Children's Privacy
              </h2>
              <p className="leading-relaxed" data-id="element-528">
                Our platform is designed for general audiences. We do not
                knowingly collect personal information from children under 13.
                If you believe we have inadvertently collected such information,
                please contact us so we can delete it.
              </p>
            </section>

            <section data-id="element-529">
              <h2 className="text-2xl font-bold text-black mb-4" data-id="element-530">
                7. Changes to This Policy
              </h2>
              <p className="leading-relaxed" data-id="element-531">
                We may update this policy occasionally as our platform evolves.
                We will notify users of any significant changes by updating the
                "Last updated" date at the top of this page.
              </p>
            </section>

            <section data-id="element-532">
              <h2 className="text-2xl font-bold text-black mb-4" data-id="element-533">
                8. Contact Us
              </h2>
              <p className="leading-relaxed" data-id="element-534">
                If you have any questions about this Privacy Policy or how we
                handle your data, please reach out to us at
                privacy@skeuomorphic.xyz.
              </p>
            </section>
          </motion.div>
        </motion.section>
      </main>

      {/* Footer */}
      <footer className="border-t border-grey-200" data-id="element-535">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-6 sm:py-8" data-id="element-536">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3 text-sm text-grey-500" data-id="element-537">
            <p className="text-center sm:text-left" data-id="element-538">
              © 2026 4ALL AI | All Rights Reserved by Skeuomorphic xyz
            </p>
            <div className="flex items-center gap-6" data-id="element-539">
              <Link to="/privacy" className="hover:text-black transition-colors" data-id="element-540">
                Privacy
              </Link>
              <Link to="/terms" className="hover:text-black transition-colors" data-id="element-541">
                Terms
              </Link>
            </div>
          </div>
        </div>
      </footer>
    </div>;
}